import { render, staticRenderFns } from "./ArticleContentTilda.vue?vue&type=template&id=d84fc47e"
import script from "./ArticleContentTilda.vue?vue&type=script&lang=ts"
export * from "./ArticleContentTilda.vue?vue&type=script&lang=ts"
import style0 from "./ArticleContentTilda.vue?vue&type=style&index=0&id=d84fc47e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports